import { t } from 'i18next'

export function textFrequencyFromHs(recurringbillingfrequency) {
    switch (recurringbillingfrequency) {
        case "annually":
            return t("per_year");
        case "monthly":
            return t("per_month");
        default:
            return "";
    }
}

export function getPriceCents(price) {
    const number = Number(price);
    const fixed = number.toFixed(2);
    return fixed;
}

export function getCurrencyText(price, currencyCode) {
    if (currencyCode === "") {
        return "";
    }
    return new Intl.NumberFormat(navigator.language, {
        style: "currency",
        currency: currencyCode,
    }).format(price);
}